/**
 * A página não aproxima, só o mapa (ver `index.css`). O Safari do iPhone ignora
 * `user-scalable=no` e o `touch-action` do `<html>` para a pinça: aqui ela é
 * barrada fora do mapa — os gestos (`gesturestart`, só do Safari) e o toque com
 * dois dedos. Dentro do mapa (`.ol-viewport`) nada muda: o OpenLayers faz a
 * pinça dele com os eventos de ponteiro.
 */
const NO_MAPA = '.ol-viewport';

function foraDoMapa(alvo: EventTarget | null): boolean {
  return !(alvo instanceof Element && alvo.closest(NO_MAPA));
}

export function semZoomNaPagina(doc: Document = document): () => void {
  const gesto = (e: Event) => {
    if (foraDoMapa(e.target)) e.preventDefault();
  };
  const toque = (e: TouchEvent) => {
    if (e.touches.length > 1 && foraDoMapa(e.target)) e.preventDefault();
  };
  const opcoes: AddEventListenerOptions = { passive: false };
  doc.addEventListener('gesturestart', gesto, opcoes);
  doc.addEventListener('gesturechange', gesto, opcoes);
  doc.addEventListener('touchmove', toque, opcoes);
  return () => {
    doc.removeEventListener('gesturestart', gesto);
    doc.removeEventListener('gesturechange', gesto);
    doc.removeEventListener('touchmove', toque);
  };
}
